const VehiclesMain = () => import(/* webpackChunkName: "admin-module" */ './index');
const Vehicles = () => import(/* webpackChunkName: "admin-module" */ './views/Vehicles');
const Create = () => import(/* webpackChunkName: "admin-module" */ './views/Create');
const Edit = () => import(/* webpackChunkName: "admin-module" */ './views/Edit');
const Show = () => import(/* webpackChunkName: "admin-module" */ './views/Show');

export default [
    {
        path: 'vehicles',
        components: { base: VehiclesMain },
        children: [
            {
                path: '',
                name: 'vehicles',
                components: { vehicles: Vehicles }
            },
            {
                path: 'create',
                name: 'vehicles.create',
                components: { vehicles: Create }
            },
            {
                path: ':vehicle_id/edit',
                name: 'vehicles.edit',
                components: { vehicles: Edit }
            },
            {
                path: ':vehicle_id/show',
                name: 'vehicles.show',
                components: { vehicles: Show }
            }
        ]
    },
];
